import React from "react"
import { OutboundLink } from "gatsby-plugin-google-analytics"
import { OutboundLinkWrapper } from "./typography/outbound-link-wrapper"

export const ReadMoreLink = ({ url }) => (
  <OutboundLinkWrapper>
    <OutboundLink href={url} target="_blank">
      Read More
    </OutboundLink>
  </OutboundLinkWrapper>
)
